<wiz-hgroup width="100%" height="100%" verticalAlign="center">
  <wiz-hgroup width="100%" height="100%" verticalAlign="center" style="padding-left: 5px">
    <ng-container #breadContainer></ng-container>
    <wiz-spacer width="10px"></wiz-spacer> 
    <wiz-image #imgRunMode [source]="modeIcon" 
    [wizTooltip]="modeTooltip"
    class="roundedImage" width="25x" height="25px"></wiz-image> 

    <wiz-spacer width="10px"></wiz-spacer> 
    <!-- <wiz-image #imgPicto [source]="viewIcon" 
    [wizTooltip]="viewTooltip"
    class="roundedImage" width="25x" height="25px"></wiz-image> 
     -->
    <wiz-image style="aspect-ratio: 1"
              [hidden]="!viewImage"
              class="roundedImage"
              width="25x" height="25px"
              [sourceObservable]="viewImage">
    </wiz-image>

    <wiz-icon class="inner-icon roundedImage" [hidden]="!viewIcon" style="padding-top: 2.5px; padding-left: 2.5px;" [style.color]="color">
      {{viewIcon}}</wiz-icon>
    <mat-icon [hidden]="!viewMaterial" class="roundedImage" 
    style="padding-top: 2.5px; padding-left: 2.5px; font-size: 18;"
    [style.color]="color">{{viewMaterial}}</mat-icon>
    <wiz-label [wizTooltip]="tooltipText" [wizLabel]="viewLabel"></wiz-label>



  </wiz-hgroup>

  <wiz-hgroup width="300px" horizontalAlign="end" verticalAlign="center">
    <wiz-label [wizLabel]="applicationVersion"></wiz-label>
    <wiz-icon [visible]="supportVisible" class="image-white" (click)="getSupport()"
    [wizTooltip]="'$.common.support.$'" tooltipPlacement="left">message</wiz-icon>
    <wiz-icon class="image-white" (click)="getInfo()"
    [wizTooltip]="'$.common.help.$'" tooltipPlacement="left">lightbulb</wiz-icon>
    <wiz-icon class="image-white" (click)="getLanguage()"
    [wizTooltip]="'$.common.language.$'" tooltipPlacement="left">language</wiz-icon>

    <wiz-image [source]="PDF" [visible]="usePdfExport()" height="30px" width="30px" (click)="exportDatas()" 
      [wizTooltip]="'$.widget.export.pdf.$'" [useHandCursor]="true"></wiz-image>


  </wiz-hgroup>
</wiz-hgroup>
